import PropTypes from 'prop-types'

import { closeIconRed, checkMarkPurpleIcon } from 'resources/images'
import PrimaryLink from 'units/PrimaryLink'

import {
  RedemptionRequirementContainer,
  RedemptionRequirementText,
  RedemptionRequirementsFixLink,
  Icon,
} from './styles'

const RedemptionRequirementItem = ({ isRequirementMet, requirementText, fixButtonText = null, fixLink = null }) => (
  <RedemptionRequirementContainer>
    <Icon src={isRequirementMet ? checkMarkPurpleIcon : closeIconRed} />
    <RedemptionRequirementText>
      {requirementText}
      {!isRequirementMet && fixButtonText && fixLink && (
        <RedemptionRequirementsFixLink variant="transparent" tag={PrimaryLink} to={fixLink}>
          {fixButtonText}
        </RedemptionRequirementsFixLink>
      )}
    </RedemptionRequirementText>
  </RedemptionRequirementContainer>
)

RedemptionRequirementItem.propTypes = {
  requirementText: PropTypes.string.isRequired,
  isRequirementMet: PropTypes.bool.isRequired,
  fixButtonText: PropTypes.string,
  fixLink: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default RedemptionRequirementItem
